var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCad(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 660,
    height: 200,
    viewBox: "0 0 174.62 52.917",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-18.181 -4.5357)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.019688 0 0 .025584 21.205 7.1085)",
    clipRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil7 str2",
    d: "m3666.8 904.07a1795.9 829.07 0 0 1-1795.9 829.07 1795.9 829.07 0 0 1-1795.9-829.07 1795.9 829.07 0 0 1 1795.9-829.07 1795.9 829.07 0 0 1 1795.9 829.07z",
    fill: "#fefefe",
    fillRule: "evenodd",
    imageRendering: "optimizeQuality",
    stroke: "#000062",
    strokeMiterlimit: 22.926,
    strokeWidth: 150
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0084 0 0 1 -10050 -13631)",
    fillRule: "evenodd",
    imageRendering: "optimizeQuality"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fil8 fnt2",
    fill: "#000062",
    "aria-label": "CAD"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11215 14645 162.43 51.503q-37.353 135.83-124.51 202.05-86.593 65.652-220.16 65.652-165.26 0-271.66-112.63-106.4-113.19-106.4-309.02 0-207.14 106.97-321.47 106.97-114.89 281.28-114.89 152.24 0 247.33 89.988 56.597 53.201 84.895 152.81l-165.83 39.618q-14.715-64.52-61.69-101.87-46.409-37.354-113.19-37.354-92.252 0-149.98 66.218-57.162 66.218-57.162 214.5 0 157.34 56.596 224.12 56.597 66.785 147.15 66.785 66.784 0 114.89-42.448 48.107-42.447 69.048-133.57z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12270 14950h-182.24l-72.444-188.47h-331.66l-68.482 188.47h-177.71l323.17-829.71h177.15zm-308.45-328.26-114.32-307.89-112.06 307.89z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12358 14120h306.19q103.57 0 157.9 15.847 73.009 21.507 125.08 76.405 52.069 54.899 79.236 134.7 27.166 79.236 27.166 195.82 0 102.44-25.468 176.58-31.129 90.554-88.857 146.58-43.58 42.447-117.72 66.218-55.465 17.545-148.28 17.545h-315.24zm167.53 140.36v549.55h125.08q70.18 0 101.31-7.923 40.749-10.188 67.35-34.524 27.166-24.337 44.145-79.802 16.979-56.03 16.979-152.24 0-96.214-16.979-147.72t-47.541-80.367q-30.562-28.865-77.537-39.052-35.09-7.924-137.53-7.924z"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#272727"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil74",
    transform: "translate(-11093 -11482)",
    d: "m16385 11773v1081.6h258.18v120.83h-380.03v-1202.4z",
    imageRendering: "optimizeQuality"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil74",
    transform: "translate(-11093 -11482)",
    d: "m17219 12855-0.95 120.83h-503.45l295.13-1081.6h-244.26l-1.85-120.85h441.69l-301.45 1081.6z",
    imageRendering: "optimizeQuality"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil74",
    transform: "translate(-11093 -11482)",
    d: "m19195 11773v120.85h-257.12l1.3 387.24h234.49l-1.32 120.82h-234.47v452.67h268.64v120.83h-390.49v-1202.4z",
    imageRendering: "optimizeQuality"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil74",
    transform: "translate(-11093 -11482)",
    d: "m19538 11894v1081.6h-121.84v-1081.6h-142.19v-120.85h416.34v120.85z",
    imageRendering: "optimizeQuality"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil74",
    d: "m3936 291.82v1202h439.59v-1.84h-152.74c83.77 0 152.74-68.38 152.74-151.48v-897.21c0-83.08-68.97-151.48-152.74-151.48zm136.23 120.07h161.8v960.02h-161.8z",
    imageRendering: "optimizeQuality"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil74",
    d: "m4681.2 291.82c-83.77 0-152.74 68.39-152.74 151.48v897.75c0 83.09 81.47 153.31 141.56 153.31h149.02c63.15 0.64 149.01-72.08 149.01-155.17v-895.89c0-83.09-68.97-151.65-152.73-151.48zm145.29 120.08v960.55h-156.47v-960.55c52.15-0.59 103.64-0.59 156.47 0z",
    imageRendering: "optimizeQuality"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil74",
    d: "m6363.6 291.44c-83.75 0-152.73 68.39-152.73 151.48v1051h141.57v-591.1h156.47v591.1h141.56v-1051c0-83.09-68.97-151.64-152.75-151.48zm-11.16 120.08c52.14-0.6 103.62-0.6 156.47 0v373.13h-156.47z",
    imageRendering: "optimizeQuality"
  })), /*#__PURE__*/React.createElement("path", {
    className: "fil75",
    d: "m7145.9 1494h141.56v-1082.4h156.47v1082.4h141.56v-1051c0-83.09-68.97-151.64-152.72-151.48h-63c-44.45 0-97.78 52.08-99.08 90.64-6.58-37.26-69.12-90.74-120.15-90.64l-44.56 0.6c-60.32 0.59-96.16 36.63-115.3 68.15 0 0 4.33-38.96 0-68.15h-141.95c0 22.15-0.82 123.91-0.82 151.08v1051.1h141.56c0-360.82 1.19-721.64 1.19-1082.5h155.25v1082.5z",
    fill: "#811214",
    imageRendering: "optimizeQuality"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCad);
export default __webpack_public_path__ + "static/media/CAD.6c90e93146804435ce18923f2db9db1f.svg";
export { ForwardRef as ReactComponent };